<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
}
</script>

<style>
#app {
  font-family: Jost, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: #f2f2f2;
}

body {
  background-color: #f2f2f2;
}

.stop-scroll {
  overflow: hidden;
  height: 100vh;
}

@media screen and (min-width: 600px){
  body {
    margin-left: 30%;
    margin-right: 30%;
  }
}
</style>
